import React, { ReactElement, useMemo, useState, useEffect } from "react";
// import * as t from "io-ts";
import { match } from "ts-pattern";
import {
  useToggle,
  ErrorState,
  CenterSpinner,
  Box,
  Pagination,
  NoData,
} from "ui-components";
// import { useQuery } from "react-query";
import { useMutation, UseQueryResult, UseMutationResult } from "react-query";
// import { CompanyResultT } from "ui-io/queries/get-companies";
import {
  companiesMutation,
  CompanyResultT,
} from "ui-io/queries/get-filtered-companies";
// import { getCompanies } from "ui-io/queries/get-companies";
import CompanyTable from "./table";
import CompanyDetails from "./details";
import { formatLargeNumber } from "ui-lib";
import moment from "moment";

type Props = {
  title?: ReactElement;
  pageSize?: number;
  currentPage?: number;
  setCurrentPage?: (val: number) => void;
  isPagination?: boolean;
  companyData?: CompanyResultT;
  companyMutation: UseMutationResult<any, any, any, any>;
};

const Company = (props: Props) => {
  // const [currentPage, setCurrentPage] = useState(0);
  const {
    title,
    pageSize = 0,
    currentPage = 0,
    setCurrentPage,
    isPagination = false,
    companyData,
    companyMutation,
  } = props;

  const [currentCompany, setCurrentComapny] = useState<any>();
  const [isCompanyDetail, setToggleCompanyDetail] = useToggle(false);
  // const [companyData, setCompanyData] = useState<CompanyResultT | null>(null);

  // const connection = useQuery(
  //   getCompanies({ pageSize: pageSize, page: currentPage })
  // );

  //  const onMount = useMutation(companiesMutation, {
  //   onSuccess: (response: CompanyResultT) => {
  //     setCompanyData(response);
  //   },
  //   onError: () => {
  //     setCompanyData(null);
  //   },
  // });

  // // Fetch on mount if no customData
  // useEffect(() => {
  //   if (!customData) {
  //     onMount.mutate({
  //       filterObject: undefined,
  //       page: currentPage,
  //       pageSize: pageSize || 20,
  //     });
  //   } else {
  //     setCompanyData(customData);
  //   }
  // }, [customData, pageSize, currentPage]);

  const fundingRoundData: any[] = useMemo(() => {
    if (!companyData?.content?.length) {
      return [];
    }

    return companyData?.content.map((company: any) => {
      const latestFunding = company?.funding_rounds?.reduce((latest: any, round: any) => {
        if (!latest) return round;
        if (!round?.date) return latest;
        if (!latest?.date) return round;

        const latestDate = new Date(latest.date).getTime();
        const currentDate = new Date(round.date).getTime();

        return Number.isNaN(currentDate) ? latest : currentDate > latestDate ? round : latest;
      }, undefined);

      let headcount,
        prevHeadcount,
        headcountGrowth: number | undefined = 0;

      if (company?.emp_count?.length && company?.emp_count?.length > 2) {
        headcount = company.emp_count?.at(-1)?.count?.to;
        prevHeadcount = company?.emp_count?.at(-2)?.count?.to;
      }

      if (headcount && prevHeadcount) {
        headcountGrowth = Math.floor(
          ((headcount - prevHeadcount) / prevHeadcount) * 100
        );
      }
      const address: any =
        company?.address?.length &&
        company.address.find(
          (i: Record<string, string>) =>
            i.type === "REGISTERED" || i.type === "HEADQUATER"
        );

      return {
        companyID: company.companyID,
        companyName: company.name,
        url: company.url,
        industry: company?.industry?.industry,
        sub_industry: company?.industry?.sub_industry,
        highlights: company.tags,
        latestFunding: latestFunding?.date && latestFunding?.amount ? (
          <>
            <strong>£{formatLargeNumber(latestFunding.amount)} </strong> on {moment(latestFunding.date).format('MMM YYYY')}
          </>
        ) : 'N/A',
        foundingDate: company.incorporation_date ? moment(company.incorporation_date).format('MMM YYYY'):"N/A",
        headcountGrowth: `${headcountGrowth} %`,
        stageOfFunding: latestFunding?.stage,
        relevancyScore: "95%",
        description: company.description,
        teamLinkedInProfiles: company?.url?.linkedin,
        team: company?.management?.at(-1)?.name,
        webTraffic90d: "50",
        headcount: headcount,
        state: address?.state || "",
        country: address?.country || "",
      };
    });
  }, [companyData]);

  const handleCompanyDetails = (company: any) => {
    setCurrentComapny(company);
    setToggleCompanyDetail();
  };
  const totalNumberOfPages = companyData?.totalNumberOfPages ?? 0;
  return (
    <div className={"w-100"}>
      <CompanyDetails
        isCompanyDetail={isCompanyDetail}
        setToggleCompanyDetail={setToggleCompanyDetail}
        currentCompany={currentCompany}
      />

      {match(companyMutation)
        .with({ status: "loading" }, { status: "idle" }, () => (
          <CenterSpinner />
        ))
        .with({ status: "error" }, ({ error }) => <ErrorState error={error} />)
        .with({ status: "success" }, ({ data }) =>
          companyData?.content?.length === 0 ? (
            <NoData
              title="No Data Found"
              icon="warning-sign"
              description={"Refine the filter to retrieve accurate results."}
            />
          ) : (
            <>
              {isPagination && totalNumberOfPages > 1 && (
                <Box mt="medium" justify="end">
                  <Pagination
                    cursor={currentPage}
                    count={totalNumberOfPages}
                    onPaginate={(val) => setCurrentPage && setCurrentPage(val)}
                    maxCells={7}
                  />
                </Box>
              )}
              <CompanyTable
                title={title}
                fundingRoundData={fundingRoundData}
                handleCompanyDetails={handleCompanyDetails}
                isStickyFirstColumn={true}
              />
              {isPagination && totalNumberOfPages > 1 && (
                <Box mt="medium" justify="end">
                  <Pagination
                    cursor={currentPage}
                    count={totalNumberOfPages}
                    onPaginate={(val) => setCurrentPage && setCurrentPage(val)}
                    maxCells={7}
                  />
                </Box>
              )}
            </>
          )
        )
        .exhaustive()}
    </div>
  );
};

export default Company;